@if (loading()) {
  <app-loading></app-loading>
} @else {
  <ng-container *transloco="let t">
    <div class="container">
      <div class="text-center mb-3">
        <h1>{{ t('our_locations') }}</h1>
      </div>
      
      @for (location of locations; track location) {
      <p-card (click)="router.navigate([generateLocationUrl(location)])" class="mb-3 locations-card">
        <div class="flex align-items-center">
          <span class="material-icons text-indigo-500" aria-hidden="true">
            map
          </span>
          <div class="ml-3">
            <h3 class="mb-0">{{ location.id == 1 ? location.title : (location.title | translate) }}</h3>
            <p class="mb-0 mt-2">{{ location.address }}</p>
          </div>
        </div>
      </p-card>
      }
    </div>
  </ng-container>
}